import 'catalog/components/CatalogFilter/CatalogFilter.scss';

import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { flatten, uniq, find, orderBy } from 'lodash';
import MediaQuery from 'react-responsive';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { InputDropDownMultiple } from '@sm360/widget-commons-forms';
import {
    MEDIA_QUERIES,
    AnalyticsService,
    TRACKING_TAGS as TAGS,
    ADOBE_TAGS,
    AdobeService,
} from '@sm360/widget-commons-general';

import BodyStyleFilterModel from 'catalog/models/BodyStyleFilterModel.js';

/* eslint jsx-a11y/no-static-element-interactions: 0 */

class BodyStyles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllBodyStyle: false,
        };

        this.handleBodyStyleChange = this.handleBodyStyleChange.bind(this);
        this.toggleShowAllBodyStyle = this.toggleShowAllBodyStyle.bind(this);
        this.filterAvailableBodyStyles = this.filterAvailableBodyStyles.bind(this);
    }

    handleBodyStyleChange(newValues, isMultipleSelection) {
        let mappedValues = newValues;

        /* React-Select already handle the delete/push event when multipe attribut is set to true.
         * In our case, we need to hande a single selection when on Desktop and Tablet screens.
         */
        if (!isMultipleSelection) {
            mappedValues = this.props.bodyStyles.filter((bodyStyle) => bodyStyle.selected);
            const index = mappedValues.findIndex((element) => {
                return element.value === newValues[0].value;
            });

            if (index === -1) {
                mappedValues.push(newValues[0]);
            } else {
                mappedValues.splice(index, 1);
            }

            this.setState({
                showAllBodyStyle: true,
            });
        }

        this.props.resetBodyStylesFilter(mappedValues);
    }

    toggleShowAllBodyStyle() {
        const availableBodyStyles = this.filterAvailableBodyStyles();

        this.setState(
            (prevState) => ({
                showAllBodyStyle: !prevState.showAllBodyStyle,
            }),
            () => {
                if (this.state.showAllBodyStyle) {
                    this.handleBodyStyleChange(availableBodyStyles, true);
                } else {
                    if (this.props.hasAdobeTagging) {
                        AdobeService.eventTrigger(ADOBE_TAGS.CATALOG_PAGE_FILTERS_RESET(), 'global-onclick');
                    }
                    this.handleBodyStyleChange([], true);
                }
            }
        );
    }

    filterAvailableBodyStyles() {
        const { bodyStyles, models } = this.props;
        const bodyStylesWithModels = [];

        models.forEach((model) => {
            bodyStylesWithModels.push(model.bodyStyleCode);
        });

        let bodyStylesToRender = [];
        uniq(flatten(bodyStylesWithModels)).forEach((modelsStyle) => {
            const bodyStyle = find(bodyStyles, (bs) => {
                return bs.codes.includes(modelsStyle);
            });
            if (bodyStyle) {
                bodyStylesToRender = [...bodyStylesToRender, bodyStyle];
            } else {
                console.log('missing', modelsStyle);
            }
        });

        return orderBy(bodyStylesToRender, ['priority'], ['asc']);
    }

    handleBodyStyleClick(bodyStyle) {
        if (!bodyStyle.selected) {
            AnalyticsService.ga4Trigger(TAGS.BODY_STYLE(bodyStyle.label));
            AnalyticsService.ga4Trigger(
                TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, 'frameStyleTypes')
            );
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(ADOBE_TAGS.CATALOG_PAGE_BODY_STYLE(bodyStyle?.label), 'global-onclick');
            }
        }
        this.handleBodyStyleChange([bodyStyle], false);
    }

    render() {
        const { bodyStyles } = this.props;
        const availableBodyStyles = this.filterAvailableBodyStyles();
        const bodyStylesFilter = availableBodyStyles ? (
            uniq(availableBodyStyles).map((bodyStyle) => (
                <li key={bodyStyle.type}>
                    <button
                        className={`catalog-filter-type-list--single ${bodyStyle.type} ${
                            bodyStyle.selected ? 'selected' : ''
                        }`}
                        onClick={() => this.handleBodyStyleClick(bodyStyle)}
                    >
                        {bodyStyle.label}
                    </button>
                </li>
            ))
        ) : (
            <li />
        );

        const selectedOptions = bodyStyles.filter((bodyStyle) => bodyStyle.selected);
        return (
            <div className="catalog-filter-type">
                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <ul className="catalog-filter-type-list">
                        {/**
                         * isCustomBodyStyle - A flag to indicate the filters are from XMS
                         */}
                        {!this.props.isCustomBodyStyle && (
                            <li className="catalog-filter-type-name">{LocaleService.t('FILTER.BODY_STYLE.TITLE')}</li>
                        )}
                        {bodyStylesFilter}
                        <li>
                            <button className="catalog-filter-type-all" onClick={this.toggleShowAllBodyStyle}>
                                {this.state.showAllBodyStyle
                                    ? LocaleService.t('FILTER.BODY_STYLE.RESET')
                                    : LocaleService.t('FILTER.BODY_STYLE.ALL')}
                            </button>
                        </li>
                    </ul>
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <InputDropDownMultiple
                        name="bodyStylesFilter"
                        defaultValues={selectedOptions}
                        options={uniq(availableBodyStyles)}
                        label={LocaleService.t('FILTER.BODY_STYLE.TITLE')}
                        placeholder={LocaleService.t('FILTER.BODY_STYLE.SELECT')}
                        valueChange={(newSelections) => this.handleBodyStyleChange(newSelections, true)}
                        classNames={['input-dropdown not-empty']}
                    />
                </MediaQuery>
            </div>
        );
    }
}

BodyStyles.defaultProps = {
    models: Immutable.List(),
    hasAdobeTagging: false,
    isCustomBodyStyle: false,
};

BodyStyles.propTypes = {
    bodyStyles: PropTypes.arrayOf(PropTypes.instanceOf(BodyStyleFilterModel)).isRequired,
    resetBodyStylesFilter: PropTypes.func.isRequired,
    models: PropTypes.instanceOf(Immutable.List),
    hasAdobeTagging: PropTypes.bool,
    isCustomBodyStyle: PropTypes.bool,
};

BodyStyles.displayName = 'BodyStyles';

export default BodyStyles;
